<ng-template #content let-modal>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-header">
      <h4 class="modal-title">
        {{ 'User::BatchUpdate:Department:Title' | abpLocalization }}
      </h4>
    </div>
    <div class="modal-body p-0">
      <div class="container">
        <div class="mb-2">{{ 'User::BatchUpdate:SelectedUsers' | abpLocalization }}</div>
        <div class="fixed-size mb-3">
          <table mat-table [dataSource]="dataSource" class="fixed-table table-100">
            <ng-container *ngFor="let gridColumn of gridColumns">
              <ng-container matColumnDef="{{ gridColumn.columnName }}">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [style.width]="gridColumn.width"
                  [style.minWidth]="gridColumn.minWidth || gridColumn.width"
                  [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
                  container="body"
                  [ngbTooltip]="gridColumn.tooltip">
                  {{ gridColumn.header }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let user"
                  [style.width]="gridColumn.width"
                  [style.minWidth]="gridColumn.minWidth || gridColumn.width"
                  [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
                  [innerHtml]="user | objectparser : gridColumn"
                  container="body"
                  [ngbTooltip]="user | objectparser : gridColumn"
                  showTooltipIfTruncated></td>
              </ng-container>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              class="user-row-{{ myRowData.id }}"
              *matRowDef="let myRowData; columns: displayedColumns"></tr>
          </table>
        </div>
        <div class="row mb-2">
          <label for="department" class="col-3 col-form-label indicates-required-field">
            {{ 'User::BatchUpdate:NewDepartment' | abpLocalization }}
          </label>
          <div class="col">
            <ca-department-selector-v2
              id="department"
              formControlName="department"
              [cls]="'fill-width'"
              [removeClassFromNgSelect]="'ng-select-single'"
              [addClassToNgSelect]="'ng-select-multiple'"
              [hideHeader]="true"
              [multiple]="false"
              [showRadio]="true"
              [closeOnSelect]="false"
              [bringToFront]="true"
              placeholder="{{
                'CA::PleaseSelectWithThreeDots' | abpLocalization
              }}"></ca-department-selector-v2>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="btn-toolbar ng-wizard-toolbar ng-wizard-toolbar-top">
        <button
          type="button"
          container="body"
          style="margin-right: 6px !important"
          class="btn ca-btn ca-btn-neutral"
          nzType="primary"
          [disabled]="updating"
          (click)="closeModal()">
          {{ 'AbpUi::Cancel' | abpLocalization }}
        </button>
        <span class="toolbar-item">
          <mat-divider [vertical]="true" class="menu-divider"></mat-divider>
        </span>
        <button
          type="submit"
          class="btn ca-btn ca-btn-primary"
          nzType="default"
          style="margin-left: 6px"
          [disabled]="!form.valid || updating">
          <i *ngIf="!updating" class="far fa-sync"></i>
          <i *ngIf="updating" class="far fa-spinner fa-spin"></i>
          <span class="me-1 ms-2">{{ 'User::Update' | abpLocalization }}</span>
        </button>
      </div>
    </div>
  </form>
</ng-template>

<button [class]="cls" (click)="openModal(content)">{{ '::Department' | abpLocalization }}</button>
